import { useMemo } from "react";

interface UseVideoAnalyticsOptions {
  miniappId?: string;
  lessonId?: number;
  contentId?: number;
}

interface TrackWithOffsetPayload {
  offset: string;
  end_seconds: string;
}

interface TrackJumpPayload {
  from: string;
  to: string;
}

interface VideoAnalytics {
  trackClick: () => void;
  trackStart: (payload: TrackWithOffsetPayload) => void;
  trackProgress: (payload: TrackWithOffsetPayload) => void;
  trackEnd: (payload: TrackWithOffsetPayload) => void;
  trackJump: (payload: TrackJumpPayload) => void;
}

export function useVideoAnalytics(
  _options: UseVideoAnalyticsOptions,
): VideoAnalytics | null {
  // Server-side analytics aren't wired yet — these are no-ops for now.
  return useMemo(() => {
    return {
      trackClick: () => {},
      trackStart: (_payload) => {},
      trackProgress: (_payload) => {},
      trackEnd: (_payload) => {},
      trackJump: (_payload) => {},
    } satisfies VideoAnalytics;
  }, []);
}
